import type { SVGProps } from 'react';
const SvgDragMenu = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none" {...props}>
    <path
      fill="currentColor"
      fillOpacity={0.45}
      d="M16.876 1.925H1.126a.16.16 0 0 0-.161.16v1.286c0 .089.072.161.16.161h15.75c.089 0 .161-.072.161-.16V2.085a.16.16 0 0 0-.16-.161m0 12.536H1.126a.16.16 0 0 0-.161.16v1.286c0 .088.072.16.16.16h15.75c.089 0 .161-.072.161-.16v-1.286a.16.16 0 0 0-.16-.16m0-6.268H1.126a.16.16 0 0 0-.161.16V9.64c0 .089.072.16.16.16h15.75c.089 0 .161-.071.161-.16V8.353a.16.16 0 0 0-.16-.16"
    />
  </svg>
);
export default SvgDragMenu;
